import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromHyundaiMenuNgrx from './+state/hyundai-menu-ngrx.reducer';
import { HyundaiMenuNgrxEffects } from './+state/hyundai-menu-ngrx.effects';
import { HyundaiMenuNgrxFacade } from './+state/hyundai-menu-ngrx.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromHyundaiMenuNgrx.HYUNDAI_MENU_NGRX_FEATURE_KEY, fromHyundaiMenuNgrx.reducer),
    EffectsModule.forFeature([HyundaiMenuNgrxEffects]),
  ],
  providers: [HyundaiMenuNgrxFacade],
})
export class HyundaiMenuNgrxModule {}
